import { Service } from '@toeverything/infra';

import { isBackendDisabled } from '../constant';
import type { ServerService } from './server';

class DisabledEventSource extends EventTarget implements EventSource {
  readonly url: string;
  readonly withCredentials: boolean;
  readyState = 2;
  onerror: ((this: EventSource, ev: Event) => any) | null = null;
  onmessage: ((this: EventSource, ev: MessageEvent) => any) | null = null;
  onopen: ((this: EventSource, ev: Event) => any) | null = null;
  readonly CONNECTING = 0;
  readonly OPEN = 1;
  readonly CLOSED = 2;

  constructor(url: string, init?: EventSourceInit) {
    super();
    this.url = url;
    this.withCredentials = !!init?.withCredentials;
  }

  close() {
    this.readyState = 2;
  }
}

export class EventSourceService extends Service {
  constructor(private readonly serverService: ServerService) {
    super();
  }

  eventSource = (url: string, eventSourceInitDict?: EventSourceInit) => {
    if (isBackendDisabled()) {
      return new DisabledEventSource(
        String(new URL(url, this.serverService.server.baseUrl)),
        eventSourceInitDict
      );
    }
    return new EventSource(
      new URL(url, this.serverService.server.baseUrl),
      eventSourceInitDict
    );
  };
}
